import React from 'react';
import { mergeClasses } from '@fluentui/react-components';

import { useBannerStyles } from './useBannerStyles.styles';
import { CopilotRegular } from '../images/CopilotRegular';

interface IBannerProps {
  children: React.ReactNode;
  className?: string;
  locale?: string;
  narrow?: boolean;
}

export const Banner: React.FC<IBannerProps> = React.memo(({ children, className, narrow = false }) => {
  const classes = useBannerStyles();

  return (
    <div className={mergeClasses(classes.root, 'banner-container', className)}>
      <div className={mergeClasses(classes.BannerCard, narrow && classes.BannerCardNarrow, 'banner-card')}>
        <div className={mergeClasses(classes.BannerBackground, 'banner-background')} />
        <CopilotRegular className={mergeClasses(classes.BannerIcon, 'banner-icon')} />
        {children}
      </div>
    </div>
  );
});
